module.exports = __webpack_public_path__ + "img/tap.7cee177a.svg";